<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini">
          <el-form-item label="导入日期">
            <form-date-range :form="searchForm" startKey="createdDateStart" :usingTime="false" endKey="createdDateEnd" valueFormat="yyyy-MM-dd"> </form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="onReset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="isShowImport = true">导入</el-button>
      </template>
      <el-table
        border
        stripe
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :data="tableData.records"
        :height="maxTableHeight"
        v-loading="loading"
      >
        <el-table-column label="文件名" prop="fileName" min-width="200"> </el-table-column>
        <el-table-column label="任务类型" prop="taskTypeName" width="150"> </el-table-column>
        <el-table-column label="导入人" prop="createdByName" width="90"> </el-table-column>
        <el-table-column label="状态" prop="statusName" width="100"> </el-table-column>
        <el-table-column label="导入时间" prop="createdDate" width="160"> </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="onDownload(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <!-- 导入 -->
    <import-dialog :visible.sync="isShowImport" v-if="isShowImport" @success="onSearch" />
  </content-panel>
</template>

<script>
import moment from 'moment';
import importDialog from './import-dialog.vue';
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: 'CommoditySales',
  mixins: [tableMixin, pagePathMixin],
  components: { importDialog },
  data() {
    return {
      loading: false,
      loading2: false,
      searchForm: {
        createdDateStart: '',
        createdDateEnd: '',
      },
      tableData: {
        records: [],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      exportData: {},
      columnsData: [],
      isShowImport: false,
      rowData: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    onReset() {
      this.searchForm = {
        createdDateStart: '',
        createdDateEnd: '',
      };
      this.onSearch();
    },
    init() {
      this.loading = true;
      let data = {
        filterData: {
          ...this.searchForm,
          queryType: 1,
          taskType: 1
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        exportTag: false,
      };
      this.$q.product
        .fileTaskListPage({ data: JSON.stringify(data) })
        .then((res) => {
          this.tableData = res.data;
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(1);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(1);
    },
    onDownload(row) {
      this.downLoad(row.filePath, row.fileName);
    },
    downLoad(path, name) {
      let url = path;
      let fileName = name;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName);
          } else {
            var link = document.createElement('a');
            var body = document.querySelector('body');

            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;

            // fix Firefox
            link.style.display = 'none';
            body.appendChild(link);

            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send();
    },
  },
};
</script>
<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
.footerBox
  text-align right
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important

>>> .form-number-input .el-input-number {
    width: 105px !important;
}
>>> .form-number-input .el-input-number .el-input {
    width: 105px !important;
}
</style>
